import styled from 'styled-components';
import { Select } from '@material-ui/core';

export const Form = styled.div`
  position: relative;
  padding-top: 64px;
  align-items: start;
  flex-direction: column;
  display: flex;
  width: 335px;
  @media (max-width: 480px) {
    width: 100%;
    padding: 0 5vw;
    margin-top: 10vw;
  }
`;
export const BackButtonContent = styled.div`
  font-weight: 800;
  font-size: 28px;
  line-height: 34px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 32px;
  @media (max-width: 480px) {
    font-size: 8vw;
    line-height: 110%;
    margin-bottom: 7vw;
  }
`;

export const BackButton = styled.div`
  margin-right: 10px;
  @media (max-width: 480px) {
    margin-right: 4vw;
    width: 8vw;
    height: 8vw;
    svg {
      height: 100%;
      width: 100%;
    }
  }
`;

export const TextFieldWrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
  @media (max-width: 480px) {
    margin-bottom: 10px;
  }
`;

export const TextField = styled.input`
  background: #ffffff;
  width: 100%;
  border: 2px solid #ecedf0;
  box-sizing: border-box;
  border-radius: 16px;

  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  display: flex;
  align-items: center;

  color: #222224;
  padding: 20px 24px;
  margin-bottom: 16px;
  @media (max-width: 480px) {
    border-radius: 3vw;
    font-size: 4vw;
    line-height: 110%;
    padding: 5vw 5.5vw;
  }
`;
export const Privacy = styled.p`
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 32px;
  color: #7f7f82;
  a {
    text-decoration: underline;
  }
  @media (max-width: 480px) {
    font-size: 4vw;
    line-height: 110%;
    padding-left: 2vw;
    margin-bottom: 8vw;
  }
`;

export const StyledSelectForm = styled.div`
  width: 100%;
  border: 2px solid #ecedf0;
  border-radius: 14px;
  position: relative;
  margin-bottom: 16px;
  ul {
    padding: 0;
  }
  .MuiPaper-root {
    max-height: 300px;
    height: 100%;
  }
  div,
  input {
    li {
      background-color: none;
    }
    ::before {
      border: none;
      visibility: hidden;
    }
    :active {
      background: none;
    }
    ::after {
      border: none;
    }
    :hover {
      border: none;
    }
  }
  .MuiInput-underline:before {
    border: none;
  }
  .MuiInput-underline:after {
    border: none;
  }
  .MuiInput-underline:hover {
    border: none;
  }
  .MuiSelect-nativeInput {
    border: none;
  }
  .MuiSelect-nativeInput:hover {
    border: none;
  }
  .MuiInputBase-input {
    padding: 6px 12px 7px;
  }
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 14px;
  border-bottom: none;
  padding: 14px;
  tr:nth-child(even) {
    border: none;
  }
  ::before {
    border: none;
    outline: none;
  }
  div {
    ::before {
      border: none;
      outline: none;
    }
  }
`;

export const StateSelectPlaceholder = styled.p`
  font-size: 16px;
  color: #7f7f82;
`;
